export const processingCookingStep = (content: TContent): TContent => {
  return {
    ...content,
    type: 'div',
    parser_type: 'html_parser',
  };
};
